export default "__VITE_ASSET__ZYHUk7kH__"